import { get } from '@/httpRequest'

export interface ISessionHistoryRequest {
  /**
   * 用户ID或者群ID
   */
  session_id: string
  /**
   * 会话的类型：1用户，2群
   */
  session_type: number
  size: number
  timestamp?: number
}

export interface ISessionHistoryResponse {
  list: ISessionHistoryItem[]
  next: boolean
}

export interface IMessageContentExtra {
  content: string
  extra: {
    notification_type: number
    link: string
    button_name: string
  }
}

export interface ISessionHistoryItem {
  /**
   * 消息发送时间
   */
  created_at: string
  /**
   * 消息的内容
   */
  message_content: string | IMessageContentExtra
  /**
   * 消息类型,1文本2图片
   */
  message_type: number
  /**
   * 发送的用户ID
   */
  sender_user_id: string

  showTime?: boolean

  id: string
}

export const getSessionHistory = async (params: ISessionHistoryRequest) => {
  const response = await get<ISessionHistoryResponse>(
    `/imApi/session/historyMessage`,
    params
  )

  return response
}
